export const uploadBlobToS3FromClipBoard = async (presignedUrl: string) => {
  const clipboardItems = await navigator.clipboard.read();

  for (const clipboardItem of clipboardItems) {
    for (const type of clipboardItem.types) {
      if (type === 'image/png' || type === 'image/jpeg') {
        const blob = await clipboardItem.getType(type);

        const xhr = new XMLHttpRequest();
        xhr.open('PUT', presignedUrl);
        // xhr.setRequestHeader('Content-Type', type);
        // xhr.setRequestHeader('x-amz-acl', 'public-read');

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
          }
        };

        xhr.send(blob);
        return;
      }
    }
  }
};

export const uploadBlobToS3 = (presignedUrl: string, currentFile: any) => {
  return new Promise((resolve, reject) => {
    const blob = currentFile;
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', presignedUrl);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          reject(xhr.statusText);
        }
      }
    };
    xhr.onerror = function () {
      reject(xhr.statusText);
    };
    xhr.send(blob);
  });
};

export const uploadFormDataToS3 = async (presignedUrl: string, data: FormData) => {
  try {
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      body: data,
    });

    if (response.ok) {
    } else {
      console.error('Failed to upload data to S3.');
    }
  } catch (error: any) {
    console.error(`Error uploading data to S3: ${error.message}`);
  }
};
